// Ordine degli ingredienti nel Libro Ingredienti: stessa regola delle
// etichette (backend/label_compliance.py, _build_ingredients) — art. 18
// Reg. UE 1169/2011, peso decrescente al momento dell'impiego.
// Le quantità si confrontano convertite in grammi (g/gr/kg). Se anche un solo
// ingrediente non ha una quantità in peso, l'ordine decrescente non è
// verificabile: si mantiene l'ordine inserito nella ricetta, senza rimescolarlo.
const MASS_TO_G = { g: 1, gr: 1, kg: 1000 };

export function ingredientGrams(item) {
  const raw = item?.qty;
  if (raw === null || raw === undefined || raw === "") return null;
  const value = Number(String(raw).replace(",", "."));
  const factor = MASS_TO_G[String(item?.unit || "").trim().toLowerCase()];
  return Number.isFinite(value) && factor ? value * factor : null;
}

export function orderIngredientsByWeight(items) {
  const list = (items || []).slice();
  const grams = list.map(ingredientGrams);
  if (grams.some((g) => g === null)) return list;
  return list.map((item, index) => ({ item, g: grams[index], index }))
    .sort((a, b) => b.g - a.g || a.index - b.index)
    .map(({ item }) => item);
}
